module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@3x-ee2f30ee5c62465a52228bd80e917063.png";